// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { optimismSepolia as _optimismSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the optimismSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11155420
 * Chain Name: OP Sepolia
 * Default Block Explorer: https://optimism-sepolia.blockscout.com
 * Default RPC URL: https://sepolia.optimism.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { optimismSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: optimismSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const optimismSepolia = createCommon({
	..._optimismSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
